module.exports = __webpack_public_path__ + "static/media/maestro_logo_light_mobile.8b878171.svg";